<template>
  <div class="chat-message-form">
    <textarea name="" id="" placeholder="메세지를 입력해주세요."></textarea>
    <button type="button" class="button-send" aria-label="메세지 보내기">
      보내기
    </button>
  </div>
</template>
